<template>
  <div>
    <header>
      <HeaderTalkshows />
      <BreadcrumbList />
    </header>
    <div id="main">

        <section class="report">

            <div class="reportTitle">
                <div class="inner4">
                    <h1>トークショーレポート</h1><p class="titleSub">Talk Show Reports</p>
                </div><!-- /inner4-->
            </div><!-- /reportTitle-->

            <section class="reportVhead reportVhead01">
                <div class="inner4">
                    <h1><img class="" src="/img_report_fujifilm/title.png" srcset="/img_report_fujifilm/title@2x.png 2x" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" /></h1>
                </div><!-- /inner4-->
            </section><!-- /reportVhead-->

            <div class="reportBody">

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            2020年9月20日（日）～10月31日（土）、初のオンライン開催となった東京カメラ部2020写真展 Online Exhibition「それでも世界は美しい。」。<br>
                            写真展に連動し、サポート企業様、省庁・自治体様のご提供によってオンライントークショーが開催されました。<br>
                            2020年10月24日（土）は、富士フイルム「世界は色を変える。新しいXとともに」というテーマで、東京カメラ部10選の今吉優衣さんにご出演いただき、2020年11月19日（木）に発売予定のX-S10で撮影された作品の紹介とXシリーズの魅力を語っていただきました。<br>
                            <br>
                            東京カメラ部運営 塚崎（司会）「みなさん、こんにちは。本日は富士フイルム『世界は色を変える。新しいXとともに」と題しまして、今吉優衣さんをお迎えしてお送りいたします。今吉さんにお話をお伺いする前に、まずは富士フイルムご担当の奥山さんをご招待したいと思います。よろしくお願いいたします」<br>
                            <br>
                            奥山「富士フイルムの光学・電子映像事業部でデジタルカメラのマーケティングを担当している奥山と申します。本日は当社のサービス拠点になっている東京丸の内にあるFUJIFILM Imaging Plaza 東京から参加させていただきます」<br>
                            <br>
                            塚崎「FUJIFILM Imaging Plaza 東京とはデモ機が触れる場所ですか？」<br>
                            <br>
                            奥山「タッチアンドトライや、ギャラリーでX-S10の写真展<sup>※</sup>も開催している拠点になります」<br>
                            <span class="attention">※FUJIFILM Imaging Plaza 東京：2020年10月21日（水）～2020年11月16日（月）まで開催。</span><br>
                            <br>
                            塚崎「早速X-S10の特徴を教えてください」<br>
                            <br>
                            奥山「非常にコンパクトなボディに、最高5軸6段のボディ内手ブレ補正と、高性能の高速オートフォーカス機能、高性能の4K動画機能を搭載した最新モデルです。安定感のあるグリップの形状が特徴で、バリアングルモニターも搭載していますので、普段から本格的な撮影をしている方にもお使いいただけます。また今回、シンプルな操作性を楽しめるモードダイヤルを搭載していますので、今まで富士フイルムのカメラを使ったことがない方や、これからカメラを本格的に使おうと思っている方にもおすすめできるカメラです」<br>
                            <br>
                            塚崎「予約はもうはじまっているんですよね」<br>
                            <br>
                            奥山「はい、現在予約受付中で、おかげさまで非常に好評をいただいています」<br>
                            <br>
                            塚崎「予約している方は富士フイルムユーザーが多いのでしょうか。それとも新しい方もいらっしゃるのでしょうか」<br>
                            <br>
                            奥山「もちろん富士フイルムユーザーの方にもご好評いただいているのですが、今回はボディ本体に加えて3種類のレンズキットをご用意しています。レンズキットの予約もいただいていますので、かなり他社ユーザーの方にもご興味を持っていただいていると思います」<br>
                            <br>
                            塚崎「他社ユーザーがXシリーズを使いたい大きな理由にフィルムシミュレーションがあるとよくお伺いするのですが、その辺りは評価されているのでしょうか」<br>
                            <br>
                            奥山「富士フイルムユーザーのお客様もそうですし、カメラファンの皆様が富士フイルムならではの色再現、フィルムシミュレーションにご興味を持っているというのは感じています。X-S10も最新のフィルムシミュレーション全種類がお使いいただけるカメラです。全部で18種類ありまして、特にクラシックネガというフィルムシミュレーションは、元々フィルムを使っていた方にもかなり興味を持っていただけています」<br>
                            <br>
                            塚崎「X-T4と同じだけのフィルムシミュレーションが使えるんですよね」<br>
                            <br>
                            奥山「センサーとプロセッサーは上位機種のX-T4と同様のものになりますので、同じレベルでしっかりと撮影できる一台になっています」<br>
                            <br>
                            塚崎「ぜひ触ってみたいと思う方もいると思うのですが、その辺りはいかがでしょうか」<br>
                            <br>
                            奥山「FUJIFILM Imaging Plaza 東京と、FUJIFILM Imaging Plaza大阪ではすでにタッチアンドトライが可能です」<br>
                            <br>
                            塚崎「興味のある方は行ってみてはいかがでしょうか。奥山さんはこのあと最後にもご登場いただきたいと思います。ご覧の皆様、ご質問があればぜひお願いします。それでは引き続き東京カメラ部10選の今吉さんにご登場いただきます」<br>
                            <br>
                            塚崎「今吉さんよろしくお願いします。今回はX-S10はどれくらいの期間使われたのですか？」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/01.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            今吉「今回、一ヶ月ほど使わせていただきました」<br>
                            <br>
                            塚崎「早速、使用してどうだったかについて写真を見ながら伺っていきたいと思います。まずは最初の写真からお願いします」<br>
                            <br>
                            今吉「これは東京某所の屋上の写真なのですが、結構晴れた日でした。フィルムシミュレーションはPROVIA／スタンダードです。私は普段他社のカメラを使用していまして、富士フイルムのカメラを触るのは初めてだったのですが、私の中にある富士フイルムの青のイメージが一番きれいに出た写真かなと思います。フィルムシミュレーションも色々試したのですが、その中でも富士フイルムの色だな、とピンときた一枚です」<br>
                            <br>
                            塚崎「普段はRAWで撮影されていますか？」<br>
                            <br>
                            今吉「普段はRAWで撮って、現像ソフトでレタッチをすることを前提に撮る癖があるので、今回撮って出しで作品として仕上げるというのが初めてでした。撮って出しは初心者のわたしでもここまでのクォリティになって驚いています。RAW現像をしたことがないという方でも、フィルムシミュレーションのボタンを操作するだけでこの雰囲気が簡単に出ます」<br>
                            <br>
                            塚崎「X-S10はフィルムシミュレーションが選びやすいですよね」<br>
                            <br>
                            今吉「カメラのダイヤルを回すだけでフィルムシミュレーションが変えられるんです。操作性は本当に抜群だと思います」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/02.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>今吉「同じ場所の写真ではあるのですが、モデルさんに黒い衣装を着てもらっています。私が普段写真を撮る上で一番気にしている色が黒です。普段私の写真を見てくださっている方はくすんだ黒のイメージがあると思うのですが、富士フイルムの黒は、陶器に印刷したような透明感のあるつるっとした黒のイメージがありました」</p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/03.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「この写真を見ていただいても黒の質感はわかると思いますし、一番見ていただきたいのはモデルさんの肌です。モデルさんの真後ろ、少し上くらいから西日が差していて、完全に逆光なんです。逆光ですがモデルさんの肌の色がすごくきれいに出ていますし、持っている紫色の花も、陽が当たっている部分の色がちゃんと出ています。普段逆光で撮るときはあとでシャドウ部を持ち上げればなんとかなるか、というのが普通だったのですが、撮って出しでこのクォリティが出るのは素晴らしいと思います」<br>
                           <br>
                           塚崎「レフ板を当てたりライティングしたりしているのですか？」<br>
                           <br>
                           今吉「それは全くしていなくて、自然光です。カメラで露出を上げているくらいですね」<br>
                           <br>
                           塚崎「『富士フイルムの色味は他社には再現できない技術でポートレートには最適ですね』とコメントが来ています」<br>
                           <br>
                           今吉「本当にそう思います。普段使っている他社のRAWデータから富士フイルムの色を再現してみようとしたことがありました。ハイライトに青を乗せればいいのかなと思ったのですが、なかなか上手くいかず、やはり富士フイルムならではの色だなと思いました。アンダーで撮って、顔の部分だけマスクをかけて明るくして、という手間がなくこのクォリティが出るのはすごいと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/04.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「同じ日に撮影した写真です。二子玉川の河川敷で、陽が沈む直前ですね。西日を直接受けているところを撮ると、普通は白飛びするかオレンジが強く出すぎてしまうかだと思うのですが、こうしてアンダー目に撮っても黒潰れしませんし、西日が当たっていることがわかりつつも肌の質感がしっかり出ています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/05.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           塚崎「次の写真も同じ夕方の時間帯ですね」<br>
                           <br>
                           今吉「夕方で、同じ二子玉川の河川敷から撮影した写真です。空の色を見ていただきたくて。電車に西日がしっかり当たっていて、かつ空の飛びやすい青もしっかり色が出ています。現像ソフトでの部分補正がいらないな、と感じました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/06.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           塚崎「次の写真は月ですね」<br>
                           <br>
                           今吉「先程と同じ場所から撮っています。月の明るいところと、空の深い紫が両方はっきり発色しています。明るい空も暗い空も、これだけ色を出してくれるんですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/07.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「先程の写真は空が青かったと思うのですが、この写真は夕暮れの紫がかったきれいなピンク色の空です。現像ソフトでは出しきれない色がすごく出ているのと、モデルさんの顔に若干光が当たっているところと当たっていないところの明暗差がはっきり出ていて、すごい性能だと思います」<br>
                           <br>
                           塚崎「『一番お気に入りのフィルムシミュレーションはなんですか？』という質問が来ています」<br>
                           <br>
                           今吉「ここまでの写真は全てPROVIA／スタンダードで撮影しているのですが、個人的にはクラシックネガがお気に入りです。この後ご紹介しますので楽しみにしていてください」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/08.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           塚崎「早速クラシックネガで撮られた写真をご紹介します」<br>
                           <br>
                           今吉「神奈川県三浦半島の馬の背洞門に行く道中に撮影しました。クラシックネガと緑の相性がすごく良いなと感じていて、奥の方の緑にも注目していただきたいです。光の捉え方も美しくて、陽だまりの雰囲気も出ていますし、スカートも白飛びしていません。これで撮って出しというところが魅力だと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/09.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           塚崎「モノクロにするとこうなります」<br>
                           <br>
                           今吉「元々モノクロで撮影してみたい願望がありつつもなかなか手が出ず、今回フィルムシミュレーションでモノクロがあったので、ここぞとばかりに使用してみました。カラーで撮ったものの彩度を下げればいいのかな、という安直な考えがどこかにあったのですが、やはりそういうわけではなく。富士フイルムのフィルムシミュレーションを使うと、陽だまりの当たっているところ、当たっていないところ、白いドレスの白の使い分けが素晴らしく、色々な白の表現が美しいと感じました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/10.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           塚崎「こちらもクラシックネガで撮られた写真です」<br>
                           <br>
                           今吉「モデルさんの肌の色と、ドレスの色が本当にきれいに発色しています。岩場の質感にも注目していただければと思います」<br>
                           <br>
                           塚崎「『トーンカーブの調整はカメラ内でしていますか？』という質問が来ています」<br>
                           <br>
                           今吉「細かい調整はしていないですが、ハイライトを若干落として白飛びしないようにしています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/11.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                         今吉「雲が多めで、その隙間から太陽が覗いているような天気だったのですが、空の描写に注目していただきたくて。陽が当たっているところと、当たっていないところ、灰色の雲と晴れているところ。カラーはもちろん、モノクロで撮影してもそこがしっかりと出ているので、さすが富士フイルムのモノクロだなと感じました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/12.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「クラシックネガと一番相性が良かった写真だと思っています。緑が強く出るフィルムシミュレーションだと思っているのですが、その緑がモデルさんの肌やドレスの白を邪魔せず発色してくれるのが良かったです」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/13.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「深い緑とモデルさんの肌の色がきれいです。カメラ内でハイライトを抑える設定ができるので、ドレスの裾のしわの部分まで表現できています。神奈川県で撮ったのに、まるで海外のように見えますよね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/14.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           塚崎「次は猫の写真です」<br>
                           <br>
                           今吉「野良猫なのですが、すごくかわいくて。ちょこまか動き回るのですが、AFがサクッと合わせてくれるので、ちょうど伸びをしているところも抑えることができました。動物にAFの性能はとても大切だと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/15.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           塚崎「ここからはスナップ系でしょうか」<br>
                           <br>
                           今吉「台風が日本の南に来たときがあったと思います。わたしは雨の日のスナップがとても好きで、台風の予報が出ていましたが、このくらいの雨なら撮れるかもと思い、カメラを持って出かけたときに撮りました。雨の日のスナップは、手が足りないんですよね。片手で傘を持っているので、カメラの操作は1.5本の腕くらいの感覚でやらないといけないのですが、右手でグリップを持ちながらフィルムシミュレーションを変えたりしていました。AFの位置もボタンで割り当てられるのでそれも便利ですね。とても軽く、片手でもずっと撮影することができました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/16.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「ここは日本橋の高架下ですが、クラシックネガで撮っています。コンクリートとクラシックネガの組み合わせはこうなるんだ、とわたし自身発見があった1枚です。重めのコンクリートが表現できていると思います。これも左手で傘を持ちながら片手で撮影をしています。ボディがコンパクトでグリップも深いので、雨の日でも握りやすく、片手でも十分に撮影することができます。手ブレ補正もついていますし安心ですね」<br>
                           <br>
                           塚崎「本来、写真は両手で撮るというのがセオリーですが、片手でも心配なく撮ることができるのならば、それはいいですよね。『女性が片手で撮るというのは辛そうですが、そんなことなかったのですね』というコメントが来ています」<br>
                           <br>
                           今吉「本当に辛くなくて軽いです。この日も雨の中、2、3時間くらいは撮影をしていましたが疲れなかったですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/17.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           塚崎「雨の東京という雰囲気の1枚です」<br>
                           <br>
                           今吉「これも日本橋ですが、ソール・ライターが好きで、その作風を意識して撮影しました。ただの通行人ですが、自分の横をかすめ通って行った瞬間に振り返り撮影しました、それでもAFが間に合うくらいにAFスピードは速いと思います」<br>
                           <br>
                           塚崎「スナップを撮る方は、あらかじめピントを置いておいて撮る『置きピン』での撮影が主流でしたが、いまでは完全にAFで撮れるということですね」<br>
                           <br>
                           今吉「勝手にカメラが追尾してくれるのでとても撮りやすかったです」<br>
                           <br>
                           塚崎「昔のスナップ写真家は置きピンの位置が3メートルであれば、3メートルの位置を叩き込むための特訓をしていたそうです。AFが効くならそんな特訓は必要ないですもんね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/18.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「横断歩道を渡っている人を遠くから撮っています。かなり雨が降ってきて、ビルの向こうの煙っている感じ、信号の赤は発色しつつ、横断歩道を渡っている人がしっかりと際立っているので、個人的にもお気に入りの1枚です」<br>
                           <br>
                           塚崎「『雨と赤いポイントがソール・ライターのようですね』というコメントです」<br>
                           <br>
                           今吉「完全に意識をしているので、そのように言っていただけてとても嬉しいです」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/19.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「さきほどの写真は歩道から撮っていましたが、この1枚はわたし自身が横断歩道を渡りながら撮っています。こういう風に撮ろうと思っていたわけではなくて、ふと横を見たら傘を持っている方が歩いていて、カメラの設定を気にする時間もなくかなりわぁっと撮っています。後で見返してみたらしっかりとピントも合っていて、カメラの性能に助けられた1枚だと思っていますね。自分も相手も動いていてもこれだけピントが合うというのが素晴らしいです」<br>
                           <br>
                           塚崎「『この1枚も信号がアクセントになっていますね』というコメントです」<br>
                           <br>
                           今吉「そうですね。傘も通行人の方も暗いので、挿し色として信号を使うと、作品全体が味のあるものになると思います。そして全体の色のまとまりは、フィルムシミュレーションを使うだけで出てきますね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/20.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「これもソール・ライターだなと言われそうですね。東京駅の丸の内側のほうです。雨の日なので街灯も点っていて、そこに女性が歩いてきました。人ではなく手前の柵にピントが来てしまうことが考えられるシチュエーションでしたが、それでもしっかり人物に合わせてくれたのでAF性能は高いと思います」<br>
                           <br>
                           塚崎「質問が来ています。『使用レンズはなんですか？』」<br>
                           <br>
                           今吉「いつもはXF23mmF1.4 Rで全て撮影しています。この写真は少し遠目からだったのでXF56mmF1.2 Rを使っています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/21.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           塚崎「靄（もや）の雰囲気が良い東京駅の1枚です」<br>
                           <br>
                           今吉「手前が有名な東京駅舎、奥が解体中のビルのようですが、そこに靄がかかっていて目を引きました。これもクラシックネガを使っています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/22.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「これは銀座です。手前の傘じゃなくて後ろのビルに敢えてピントを合わせています。動いたものにオートでピントが合いやすい中で、背景にフォーカスポイントを固定して撮影をしています。このような細かい設定も簡単にできます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/23.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「お気に入りの1枚です。銀座で撮影をしています。もともとは赤い傘の人を入れる予定はなかったのですが、構えていたところに赤い傘の人が入ってきたという偶然の1枚です。良い前ボケになってくれたと思っています」<br>
                           <br>
                           塚崎「ポートレートだけでなく、スナップシューターとしても実力のあるカメラですね」<br>
                           <br>
                           今吉「本当にどちらでもとても良い写真が撮れると思います」<br>
                           <br>
                           塚崎「『スナップはファインダーと液晶モニターのどちらを使っていますか？』という質問です」<br>
                           <br>
                           今吉「わたしは液晶モニターを使っています。タッチパネルでAFを合わせたりシャッターも切ることができます。シャッターボタンを押すよりも画面をタッチするほうが速いので、よくそんな撮り方もしています」<br>
                           <br>
                           塚崎「新世代の撮影方法ですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/24.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「この中には色付きの傘の方もいたと思いますが、白黒にすることによって濃淡だけでまとめられるのと、手前の横断歩道の白黒が相待って、モノクロであることでまとまった作品だと思います。黄色とかカラフルなものが混ざってしまうとバランスが崩れたかもしれません」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/25.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「ここからはモデルさんを立てて撮影をしています。神保町の古書店街。これは完全に曇りだったのですが、わずかに光がある方向をモデルさんに向いてもらったところ、まるでレタッチしたかのような肌の質感になりました。落ち着いた色合いですが、出したい色はしっかりと見つけてくれるという印象です」<br>
                           <br>
                           塚崎「色が抑えめで趣があると思います。色が落ち着いた写真が多いですが、現像処理をしなくてもその色がでるのはいいですね。『背景の本もいろいろな色があり邪魔しがちですが、ミュートされていて良いバランスですね』というコメントも来ています」<br>
                           <br>
                           今吉「絶妙なラインの色が出ると思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/26.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「後ろがレンガ調の建物。そしてモデルさんもハーフの方なので、モノクロ（ACROS）で撮影をするとまるで映画のような雰囲気に仕上がっていると思います」
                          </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/27.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「後ろのレンガの色が落ち着いているので、最も目立たせたかったモデルさんが持っている赤い花に目がいくと思います。その狙い通りにフィルムシミュレーションを微調整して撮影しました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="/img_report_fujifilm/28.jpg" alt="富士フイルム株式会社「世界は色を変える。新しいXとともに」" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                           今吉「シャドウもしっかりと出ています」<br>
                           <br>
                           塚崎「階調が残っているモノクロ、という印象があります」<br>
                           <br>
                           今吉「今回、X-S10で撮影した写真の中では、個人的には最も傑作だと思っている1枚です。入ったカフェがガラス張りで、口元のクモリはモデルさんにハアって息を吹きかけてもらっています。さらに建物の写り込みの位置も調整して、瞳がしっかりと出るようにしています。瞳の黒がモノクロで印象的に表現できると思います」<br>
                           <br>
                           <br>
                           塚崎「今吉さん、どうもありがとうございます。引き続き、富士フイルムの奥山さんにご登壇いただき、質問にご回答いただこうと思います。『左のダイヤルには、フィルムシミュレーションだけでなく他の設定も割り当てられるのですか？』という質問が来ています」<br>
                           <br>
                           奥山「はい。他の機能も割り当て可能になっています。デフォルトはフィルムシミュレーションになっていますが、ファンクションの設定から他の機能を割り当てることができます」<br>
                           <br>
                           塚崎「『富士フイルムのS5 Proを長年使っており、色が素晴らしくて気に入っていました。特にX-S10で最も力を入れて改良したところはどこですか？』というご質問です」<br>
                           <br>
                           奥山「Xシリーズの色、操作性、性能はそのまま継承していますが、特にグリップの形状やシンプルなモードダイヤル、カスタム設定など、初めて富士フイルムのカメラを使うという方にも使いやすいカメラになっていると思います」<br>
                           <br>
                           塚崎「試したいという方は東京と大阪以外ではどこで実機を触ることができますか？」<br>
                           <br>
                           奥山「東京、大阪、名古屋、札幌の全国4カ所で週末にX-S10をレンタルすることができるイベントを開催予定です。直近ですと東京にて2020年11月14日<sup>※</sup>を予定しており既に受付もスタートしています。今後は巡回していきますのでぜひご参加ください。応募多数の場合は抽選になってしまいますが、実機数も多くお試しいただけるようにしています。当社のウェブやSNSをチェックいただければと思います」<br>
                           <span class="attention">※応募期間は2020年11月5日（木）にて終了しております。</span><br>
                           <br>
                           塚崎「本日はどうもありがとうございました」<br>
                           <br>
                           <br>
                           今回ご紹介したX-S10について詳しくは<a href="https://fujifilm-x.com/ja-jp/products/cameras/x-s10/" target="_blank">こちら</a>
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="movBlock">
                    <div class="inner4">
                        <h2>このレポートのアーカイブ動画</h2>
                        <iframe width="560" height="315" src="https://www.youtube.com/embed/j5e_zjGU0g8" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                    </div><!-- /inner4-->
                </section><!-- /movBlock-->

                <section class="btnBlock">
                    <div class="inner4">
                      <router-link to="/talkshows" class="StandardBtn">オンライントークショートップ</router-link>
                    </div><!-- /inner4-->
                </section><!-- /btnBlock-->

            </div><!-- /reportBody-->

        </section><!-- /report-->

    </div><!-- /main-->
    <Footer />
    <UpButton />
    <QuestionnaireButton />
  </div>
</template>
<script>
import HeaderTalkshows from '@/components/modules/HeaderTalkshows.vue'
import BreadcrumbList from '@/components/modules/BreadcrumbList.vue'
import Footer from '@/components/modules/Footer.vue'
import UpButton from '@/components/modules/UpButton.vue'
import QuestionnaireButton from '@/components/modules/QuestionnaireButton.vue'

export default {
  components: {
    HeaderTalkshows,
    BreadcrumbList,
    Footer,
    UpButton,
    QuestionnaireButton
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  computed: {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to, from) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}

</style>
